"use client";
import Link from "next/link";

const PrivacyPolicy = () => {
    return (
        <main className="max-w-3xl mx-auto px-6 py-20">
            <header className="mb-12">
                <h1 className="text-5xl font-extrabold text-gray-900 mb-2">
                    Privacy Policy
                </h1>
                <p className="text-sm text-gray-500">
                    Last updated: June 30, 2025
                </p>
            </header>

            <section className="space-y-10 text-base text-gray-800 leading-relaxed">
                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        1. What We Collect
                    </h2>
                    <p>
                        We collect minimal information — only what’s necessary
                        to provide a better experience. This includes:
                    </p>
                    <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700">
                        <li>Email address (if you subscribe)</li>
                        <li>Basic usage data (via analytics)</li>
                        <li>Any messages you send via the contact form</li>
                    </ul>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        2. How It's Used
                    </h2>
                    <p>
                        We use your data strictly to operate this blog — no
                        spam, no selling. Your info helps us:
                    </p>
                    <ul className="list-disc list-inside mt-2 space-y-1 text-gray-700">
                        <li>
                            Send you occasional email updates (if you opt in)
                        </li>
                        <li>Understand how the site is used (via analytics)</li>
                        <li>Improve site content and performance</li>
                    </ul>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        3. Cookies
                    </h2>
                    <p>
                        We use cookies only where necessary. You may disable
                        cookies in your browser settings if preferred.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        4. Third-Party Tools
                    </h2>
                    <p>
                        We may use services like Google Analytics or AdSense.
                        These tools may collect anonymized data via cookies. We
                        do not share or sell any personally identifying
                        information.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        5. Your Rights
                    </h2>
                    <p>
                        You can request to access or delete your data at any
                        time. Just{" "}
                        <Link
                            href="/contact"
                            className="text-blue-600 hover:underline font-medium"
                        >
                            contact us
                        </Link>
                        .
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        6. Policy Changes
                    </h2>
                    <p>
                        We may occasionally update this Privacy Policy.
                        Revisions will be posted here with an updated date.
                    </p>
                </div>

                <div>
                    <h2 className="text-2xl font-semibold mb-2 text-gray-900">
                        7. Contact
                    </h2>
                    <p>
                        Have questions or concerns? Reach out anytime via our{" "}
                        <Link
                            href="/contact"
                            className="text-blue-600 hover:underline font-medium"
                        >
                            contact page
                        </Link>
                        .
                    </p>
                </div>
            </section>
        </main>
    );
};
export default PrivacyPolicy;
